import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Heading from './Heading'

const ServiceComponent = ({ heading, description, services, benefits, image }) => {
  return (
    <section className="py-10">
      <div className="container mx-auto px-5 mt-6">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div className="relative min-h-[550px]">
            <img
              className="absolute w-full h-full object-cover rounded-lg"
              src={image}
              alt={heading}
            />
          </div>
          <div>
            <Heading name={heading} tstyle="mt-2 mb-4" />
            <p className="mb-4 text-justify">{description}</p>
            
            <h1 className="text-lg uppercase font-bold my-1">Services Offered:</h1>
            <ul className="mb-4 text-justify list-disc pl-5">
              {services.map((service, index) => (
                <li key={index}>{service}</li>
              ))}
            </ul>
            
            <h1 className="text-lg uppercase font-bold my-1">Benefits:</h1>
            <div className='mt-6'>
              {benefits.map((benefit, index) => (
                <div key={index} className="mb-4">
                  <h5 className="flex items-center font-semibold">
                    <div className="p-4 bg-emerald-600 opacity-90 text-white flex items-center justify-center w-12 h-12 mr-4">
                      <FontAwesomeIcon className="text-xl" icon={benefit.icon} />
                    </div>
                    {benefit.title}
                  </h5>
                  <p className="text-justify">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceComponent;
